import LoadingComponent from '@/pages/components/loadingComponent'
import Loadable from 'react-loadable'

export default [
  {
    component: Loadable({
      loader: () => import('@/pages/levelSys/myLevel/index'),
      loading: LoadingComponent
    }),
    path: '/courierView/levelSys/myLevel',
    exact: true,
    meta: {
      title: '我的等级'
    }
  },
  {
    component: Loadable({
      loader: () => import('@/pages/levelSys/myLevelRecord/index'),
      loading: LoadingComponent
    }),
    exact: true,
    path: '/courierView/levelSys/myLevelRecord',
    meta: {
      title: '我的等级历史变化'
    }
  },
  {
    component: Loadable({
      loader: () => import('@/pages/levelSys/fullLevel/index'),
      loading: LoadingComponent
    }),
    exact: true,
    path: '/courierView/levelSys/fullLevel',
    meta: {
      title: '全部等级'
    }
  },
  {
    component: Loadable({
      loader: () => import('@/pages/levelSys/finishYears/index'),
      loading: LoadingComponent
    }),
    exact: true,
    path: '/courierView/levelSys/finishYears',
    meta: {
      title: '完单年限'
    }
  },
  {
    component: Loadable({
      loader: () => import('@/pages/levelSys/experienceDetails/index'),
      loading: LoadingComponent
    }),
    exact: true,
    path: '/courierView/levelSys/experienceDetails',
    meta: {
      title: '经验值明细'
    }
  },
  {
    component: Loadable({
      loader: () => import('@/pages/levelSys/levelDesc/index'),
      loading: LoadingComponent
    }),
    exact: true,
    path: '/courierView/levelSys/levelDesc',
    meta: {
      title: '等级说明'
    }
  }
]
